/**
 * Chummys mega menu: hovering a link on the left previews its own picture on
 * the right (the product's featured image, or the collection's), with the
 * link's name on a chip. The panels arrive through the Section Rendering API
 * after the first hover, so the header is watched for them.
 */
(() => {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  const bind = (list) => {
    if (list.dataset.megaBound) return;
    const visual = list.querySelector('[data-mega-visual]');
    const links = list.querySelectorAll('.mega-menu__nav a[data-preview]');
    if (!visual || !links.length) return;
    list.dataset.megaBound = '1';
    const preview = visual.querySelector('[data-mega-preview]');
    const label = visual.querySelector('[data-mega-label]');
    let timer = null, token = 0;
    const show = (a) => {
      const src = a.dataset.preview; if (!src || !preview) return;
      const mine = ++token;
      if (label) { label.textContent = a.textContent.trim(); label.hidden = false; }
      const reveal = () => { if (mine === token) visual.classList.add('is-previewing'); };
      if (preview.getAttribute('src') === src && preview.complete) { reveal(); return; }
      preview.onload = reveal;
      preview.src = src;
    };
    const hide = () => { token++; visual.classList.remove('is-previewing'); if (label) label.hidden = true; };
    links.forEach((a) => {
      a.addEventListener('mouseenter', () => { clearTimeout(timer); timer = setTimeout(() => show(a), 70); });
      a.addEventListener('mouseleave', () => { clearTimeout(timer); timer = setTimeout(hide, 140); });
      a.addEventListener('focus', () => show(a));
      a.addEventListener('blur', hide);
    });
    list.addEventListener('mouseleave', hide);
  };
  const scan = () => document.querySelectorAll('.mega-menu__list').forEach(bind);
  scan();
  const root = document.querySelector('.header-section') || document.body;
  new MutationObserver(scan).observe(root, { childList: true, subtree: true });
})();

/**
 * Header ground — the bar takes the colour of whatever the page opens on.
 * The theme paints the header white; most Chummys pages open on paper
 * (#faf7f0), and a white strip over paper reads as a mistake. Instead of
 * listing templates, read the first content section's own background and
 * hand it to the CSS (assets/chummys-header.css §6) as --chummys-header-ground.
 * Photo/video openers and dark bands are left alone: the theme's transparent
 * header covers the first, and ink-on-dark would not be readable for the second.
 */
(() => {
  const root = document.documentElement;
  const opaque = (bg) => bg && bg !== 'transparent' && !/rgba\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*,\s*0\s*\)/.test(bg);
  const light = (bg) => { const m = bg.match(/(\d+(?:\.\d+)?)/g); if (!m || m.length < 3) return false; const [r, g, b] = m.map(Number); return (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255 > 0.6; };
  const ground = () => {
    const main = document.getElementById('MainContent') || document.querySelector('main');
    if (!main) return null;
    const first = [...main.querySelectorAll(':scope > .shopify-section, :scope > section, :scope > div')].find((s) => s.getBoundingClientRect().height > 40);
    if (!first) return null;
    const top = first.getBoundingClientRect().top;
    const wide = window.innerWidth * 0.9;
    const cands = [first, ...first.querySelectorAll('*')].filter((el) => { const r = el.getBoundingClientRect(); return r.top <= top + 2 && r.width >= wide && r.height > 40; });
    for (const el of cands) {
      if (/^(IMG|VIDEO|CANVAS|PICTURE|IFRAME)$/.test(el.tagName)) return null;
      const cs = getComputedStyle(el);
      if (cs.backgroundImage && cs.backgroundImage !== 'none') return null;
      if (opaque(cs.backgroundColor)) return light(cs.backgroundColor) ? cs.backgroundColor : null;
      if (el.querySelector(':scope > img, :scope > video, :scope > picture')) { const m = el.querySelector(':scope > img, :scope > video, :scope > picture').getBoundingClientRect(); if (m.top <= top + 2 && m.width >= wide) return null; }
    }
    return null;
  };
  const apply = () => {
    const bg = ground();
    if (!bg) { root.style.removeProperty('--chummys-header-ground'); document.body.classList.remove('chummys-header-matched'); return; }
    const m = bg.match(/(\d+(?:\.\d+)?)/g);
    root.style.setProperty('--chummys-header-ground', `rgb(${m[0]} ${m[1]} ${m[2]} / 0.86)`);
    document.body.classList.add('chummys-header-matched');
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
  window.addEventListener('load', apply, { once: true });
  document.addEventListener('shopify:section:load', apply);
})();
